<script setup lang="ts">
const { menuHide } = useMenu()

const key = ref(0)

onMounted(() => {
  key.value += 1
})
</script>

<template>
  <NuxtLink
    :key="key"
    aria-label="Go to Homepage"
    class="block w-fit text-center mix-blend-difference invert transition-transform ease-out hover:scale-110"
    :to="'/'"
    title="Atlas Creative"
    @click="menuHide"
  >
    <svg
      width="53"
      class="h-auto w-[38px] lg:w-auto"
      height="41"
      viewBox="0 0 53 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.1544 24.8888C34.1544 24.8888 30.2273 18.2958 27.9611 14.4684C27.5089 13.7046 27.0599 12.9967 26.6307 12.3004C23.3071 6.90085 17.1139 7.41776 15.2227 8.28366L15.2835 8.18159L16.8869 5.48677C21.2531 -1.82892 31.8389 -1.82892 36.2035 5.48677L52.18 32.2786C54.4725 36.1241 51.7047 41.0034 47.2316 41.0034C45.0806 41.0034 43.0891 39.8709 41.9873 38.0238L34.1544 24.8888Z"
        fill="#000000"
      />
      <path
        d="M0.727392 32.4883C0.757188 32.4293 0.780362 32.3637 0.81347 32.3079L11.9592 13.8102C13.252 11.6337 15.697 10.2051 18.4251 10.2051C21.029 10.2051 23.3201 11.5418 24.6477 13.5559C24.7934 13.7757 24.7686 13.7265 25.0119 14.0972C25.0963 14.2333 25.189 14.3908 25.2751 14.5351L19.3968 24.2875L18.9565 25.0207C19.0128 25.0043 19.0691 24.9879 19.1253 24.9715C25.3993 23.1722 32.1036 25.908 35.4508 31.4649C37.5167 34.8928 39.571 38.3044 39.571 38.3044C35.6792 36.3263 30.2545 35.047 25.5797 35.047C15.0448 35.047 11.4907 39.6657 7.47474 40.7662C7.40191 40.7876 7.32742 40.804 7.25292 40.822C7.05759 40.8696 6.8606 40.9089 6.66195 40.9385C6.60898 40.9467 6.55601 40.9499 6.50303 40.9565C6.27294 40.9844 6.03952 41.0024 5.80115 41.0024C1.36637 41.0008 -1.3915 36.2902 0.727392 32.4883Z"
        fill="#000000"
      />
    </svg>
  </NuxtLink>
</template>
